import { View } from "./Clients.view";

export const Container = () => {
  return <View />;
};
